export const SET_NEW_PASSWORD_TEST_IDS = {
  submitButton: 'auth-set-password-submit',
} as const;
